module.exports = __webpack_public_path__ + "static/img/stonehenge.81d0753.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/stonehenge.jpg
// module id = Y+DG
// module chunks = 1